export const BASE_ASSET_URL: string = process.env.PUBLIC_URL + "/assets/";
export const API_URL: string = "https://api.dev.thevideovets.com/";
export const apiEndpoint: string = "https://api.dev.thevideovets.com/";

export const privacyPolicyURL = "https://mvvbucket.s3.amazonaws.com/documentation/privacy_notice.pdf";
export const privacyPolicyAtlantaURl = "https://mvvbucket.s3.amazonaws.com/documentation/privacy_policy_atlanta.pdf";
export const termsOfUseURL = "https://mvvbucket.s3.amazonaws.com/documentation/terms_of_use.pdf";
export const consentFormURL = "https://mvvbucket.s3.amazonaws.com/documentation/consentForm.pdf"
